import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-test-player',
  templateUrl: './test-player.component.html',
  styleUrls: ['./test-player.component.css']
})
export class TestPlayerComponent implements OnInit {

  public videoUrl;
  constructor(private route: ActivatedRoute, private domSanitizer: DomSanitizer) {
    if (this.route.snapshot.paramMap.get('vimeo_id') && this.route.snapshot.paramMap.get('vimeo_id') !== "") {//validamos la membresia para saber si es valida para ese país
      let vimeoId = this.route.snapshot.paramMap.get('vimeo_id');
      this.videoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(`https://player.vimeo.com/video/${vimeoId}`);
    }
  }

  ngOnInit() {
  }

}
